import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const NoDatatableIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <rect x="5.44604" y="4.85094" width="13.8768" height="14.0163" rx="3" stroke="currentColor" strokeWidth="1.75" />;
    t1 = <line x1="6.16772" y1="10.0785" x2="18.7406" y2="10.0785" stroke="currentColor" strokeWidth="1.75" />;
    t2 = <line x1="9.95062" y1="18.8672" x2="9.95062" y2="9.79064" stroke="currentColor" strokeWidth="1.75" />;
    t3 = <line x1="14.386" y1="18.8672" x2="14.386" y2="9.79064" stroke="currentColor" strokeWidth="1.75" />;
    t4 = <path d="M4 20L21 4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props || $[6] !== ref) {
    t5 = <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}{t2}{t3}{t4}</svg>;
    $[5] = props;
    $[6] = ref;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
});
export default NoDatatableIcon;